(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
	});

	initProductAccordion();
	initZoomImage();
})();

//class FloatedForm extends HTMLElement {
//	constructor() {
//		super();
//		this.renderForm();
//	}

//	renderForm() {
//		fetch(this.getAttribute("data-product-url"))
//			.then((response) => response.text())
//			.then((responseText) => {
//				const responseHTML = new DOMParser().parseFromString(
//					responseText,
//					"text/html"
//				);
//				this.productElement = responseHTML.querySelector(
//					'div[id^="ProductInfo-"]'
//				);

//				this.preventDuplicatedIDs();
//				this.removeDOMElements();
//				this.setInnerHTML(this, this.productElement.innerHTML);

//				if (window.Shopify && Shopify.PaymentButton) {
//					Shopify.PaymentButton.init();
//				}

//				if (window.ProductModel) window.ProductModel.loadShopifyXR();

//				this.showMoreFields();
//			})
//			.finally(() => {
//				const selectDropDown = () => {
//					$(".product__popup .product-form__controls--dropdown").each(function () {
//						const elListItem = $(this).find(".dropdown-select ul li");
//						const elItem = $(this).find(".dropdown-select ul");
//						const selectedText = $(this).find(
//							".dropdown-select .select-label"
//						);

//						selectedText.on("click", function (e) {
//							elItem.toggleClass("active");
//							if (elItem.hasClass("active")) {
//								e.stopPropagation();
//								$(document).click(function () {
//									elItem.removeClass("active");
//								});
//							}
//						});

//						elListItem.on("click", function () {
//							selectedText
//								.find("span")
//								.text($(this).text())
//								.attr("title", $(this).text());
//							elItem.removeClass("active");
//							document.activeElement.blur();
//						});
//					});
//				};

//				selectDropDown();
//			});
//	}

//	setInnerHTML(element, html) {
//		element.innerHTML = html;

//		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//		element.querySelectorAll("script").forEach((oldScriptTag) => {
//			const newScriptTag = document.createElement("script");
//			Array.from(oldScriptTag.attributes).forEach((attribute) => {
//				newScriptTag.setAttribute(attribute.name, attribute.value);
//			});
//			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//		});
//	}

//	preventDuplicatedIDs() {
//		const sectionId = this.productElement.dataset.section;
//		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
//			sectionId,
//			`floated-${sectionId}`
//		);

//		if (this.productElement.querySelectorAll("variant-selects")) {
//			this.productElement
//				.querySelectorAll("variant-selects")
//				.forEach((radio) => {
//					radio.dataset.originalSection = sectionId;
//				});
//		}

//		if (this.productElement.querySelectorAll("variant-radios")) {
//			this.productElement
//				.querySelectorAll("variant-radios")
//				.forEach((radio) => {
//					radio.dataset.originalSection = sectionId;
//				});
//		}
//	}

//	removeDOMElements() {
//		const text = this.productElement.querySelector(".product__text");
//		if (text) text.remove();

//		const tags = this.productElement.querySelector(".product__tags");
//		if (tags) tags.remove();

//    const title = this.productElement.querySelector(".product__title__wrapper");
//		if (title) title.remove();

//		const badges = this.productElement.querySelector(".product__custom-badges");
//		if (badges) badges.remove();

//    const price = this.productElement.querySelector(".price-wrapper");
//		if (price) price.remove();

//		const description = this.productElement.querySelector(
//			".product__description"
//		);
//		if (description) description.remove();

//		const sku = this.productElement.querySelector(".product__sku");
//		if (sku) sku.remove();

//		const inventory = this.productElement.querySelector(".product__inventory");
//		if (inventory) inventory.remove();

//		const pickupAvailability = this.productElement.querySelector(
//			"pickup-availability"
//		);
//		if (pickupAvailability) pickupAvailability.remove();

//		const customLiquid = this.productElement.querySelector(".custom-liquid");
//		if (customLiquid) customLiquid.remove();

//		const complementary = this.productElement.querySelector(
//			"product-recommendations--single"
//		);
//		if (complementary) complementary.remove();

//		const shareButtons = this.productElement.querySelector(".share-buttons");
//		if (shareButtons) shareButtons.remove();

//		const productModal = this.productElement.querySelectorAll(".product-popup");
//		productModal.forEach((advantage) => {
//			advantage.remove();
//		});

//		const productForm = this.productElement.querySelector("floated-form");
//		if (productForm) productForm.remove();
//	}

//	showMoreFields() {
//		$(".js-show-more").click(function (e) {
//			e.preventDefault();
//			$(this).siblings("input").removeClass("hidden");
//			$(this).siblings("label").removeClass("hidden");
//			$(this).remove();
//		});
//	}
//}

//customElements.define("floated-form", FloatedForm);

(function () {
	// Mobile thumbnail carousel for the "grid" gallery layout (<=749px only).
	// Mirrors sliderInit()/subSliderInit() in global.js, but scoped to its own
	// js-mobile-media-list / js-mobile-media-sublist classes so it never touches
	// the Swiper instances used by the thumbnail_carousel or stacked layouts.
	var MOBILE_BREAKPOINT = 749;
	var mobileSwipers = [];

	function destroyMobileMediaCarousel() {
		mobileSwipers.forEach(function (swiper) {
			if (swiper && !swiper.destroyed) swiper.destroy(true, true);
		});
		mobileSwipers = [];
	}

	function initMobileMediaCarousel() {
		if (window.innerWidth > MOBILE_BREAKPOINT) return;

		document.querySelectorAll('.product-section .js-mobile-media-list').forEach(function (mainEl) {
			if (mainEl.swiper) return; // already initialized

			var section = mainEl.closest('.product-section');
			var subEl = section ? section.querySelector('.js-mobile-media-sublist') : null;

			var subSwiper = subEl
				? new Swiper(subEl, {
						centeredSlides: true,
						centeredSlidesBounds: true,
						slidesPerView: 3,
						spaceBetween: 8,
						direction: 'horizontal',
						navigation: false,
						freeMode: false,
						watchSlidesProgress: true,
						on: {
							touchEnd: function (s) {
								var range = 5;
								var diff = s.isHorizontal()
									? s.touches.currentX - s.touches.startX
									: s.touches.currentY - s.touches.startY;
								if (Math.abs(diff) < range) {
									s.allowClick = true;
								}
							},
						},
				  })
				: null;

			var mainSwiper = new Swiper(mainEl, {
				slidesPerView: 1,
				autoHeight: true,
				spaceBetween: 4,
				navigation: {
					nextEl: section ? section.querySelector('.swiper-btn--next') : null,
					prevEl: section ? section.querySelector('.swiper-btn--prev') : null,
				},
				thumbs: {
					swiper: subSwiper,
				},
				on: {
					slideChangeTransitionStart: function () {
						if (subSwiper) subSwiper.slideTo(this.activeIndex);
					},
					slideChange: function () {
						if (window.pauseAllMedia) window.pauseAllMedia();
					},
				},
			});

			mobileSwipers.push(mainSwiper);
			if (subSwiper) mobileSwipers.push(subSwiper);
		});
	}

	function handleMobileMediaResize() {
		if (window.innerWidth <= MOBILE_BREAKPOINT) {
			initMobileMediaCarousel();
		} else {
			destroyMobileMediaCarousel();
		}
	}

	document.addEventListener('shopify:section:load', initMobileMediaCarousel);
	window.addEventListener('resize', handleMobileMediaResize);
	initMobileMediaCarousel();
})();
